import { render } from "./IOPMedicalHistoryForm.vue?vue&type=template&id=1aa11f64&scoped=true"
import script from "./IOPMedicalHistoryForm.vue?vue&type=script&lang=js"
export * from "./IOPMedicalHistoryForm.vue?vue&type=script&lang=js"

import "./IOPMedicalHistoryForm.vue?vue&type=style&index=0&id=1aa11f64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa11f64"]])

export default __exports__